import netsCallHistoryList from './nets-call-history-list';
import netsCallHistoryMenu from './components/call-history-menu/nets-call-history-menu';
import moduleConfig from './module-config';

export default angular
  .module('app.calls', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsCallHistoryList', netsCallHistoryList)
  .component('netsCallHistoryMenu', netsCallHistoryMenu);
